<template>
  <reset-password-content
    @submit="enterpriseResetPassword"
  />
</template>
<script>
import { mapActions } from 'vuex'
import ResetPasswordContent from './ResetPasswordContent'
export default {
  name: 'StudentResetPasswordContent',
  components: {
    ResetPasswordContent
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions('auth', [
      'userResetPassword'
    ]),
    async enterpriseResetPassword (params) {
      await this.userResetPassword({
        type: 'enterprise',
        params
      })
      this.$router.push({
        path: '/login/enterprise'
      })
    }
  }
}
</script>
